import { useEffect, useState } from 'react'

export const useScrollPosition = (threshold = 0) => {
  const [isPast, setIsPast] = useState(false)

  useEffect(() => {
    let frame = null

    const handleScroll = () => {
      if (frame !== null) return

      frame = window.requestAnimationFrame(() => {
        setIsPast(window.scrollY > threshold)
        frame = null
      })
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (frame !== null) window.cancelAnimationFrame(frame)
    }
  }, [threshold])

  return isPast
}
